module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/001-589e249a193136a27daacfa30e2beaae.png";